if (!customElements.get("show-more-button")) {
  customElements.define(
    "show-more-button",
    class ShowMoreButton extends HTMLElement {
      connectedCallback() {
        const button = this.querySelector("button");
        if (!button) {
          return;
        }

        // Remove any existing listener to prevent duplicates
        if (this.clickHandler) {
          button.removeEventListener("click", this.clickHandler);
        }

        this.clickHandler = (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target
            .closest(".parent-display")
            .querySelector(".show-more-item");
          if (
            nextElementToFocus &&
            !nextElementToFocus.classList.contains("hidden") &&
            nextElementToFocus.querySelector("input")
          ) {
            nextElementToFocus.querySelector("input").focus();
          }
        };

        button.addEventListener("click", this.clickHandler);
      }

      expandShowMore(event) {
        // Use currentTarget (the button) instead of searching from target
        const parentDisplay = event.currentTarget.closest(".parent-display");
        if (!parentDisplay) {
          return;
        }

        this.querySelectorAll(".label-text").forEach((element) =>
          element.classList.toggle("hidden"),
        );
        parentDisplay
          .querySelectorAll(".show-more-item")
          .forEach((item) => item.classList.toggle("hidden"));
        if (!this.querySelector(".label-show-less")) {
          this.classList.add("hidden");
        }
      }
    },
  );
}
